import { Injectable } from '@angular/core';
import { forkJoin } from "rxjs";

import { ConfigurationHttpService } from "./configuration.service";
import { LicenseHttpService } from './license-http-service';
import { LicenseInfoDto } from "../dtos/license-info-dto";
import { RoutesGlossary } from "../glossary/routes-glossary";

/**
 * Интерсептор ответов от LC
 */

@Injectable({ providedIn: 'root' })
export class LcInterceptor {
    private idsLsEnabled: boolean = false;
    private aasEnabled: boolean = false;
    private license: LicenseInfoDto = undefined;

    constructor(
        private configService: ConfigurationHttpService,
        private licenseService: LicenseHttpService
    ) {
    }

    public init() {
        this.loadConfiguration();
    }

    private loadConfiguration(): void {
        forkJoin({
            idsLs: this.configService.getIdsLsConfiguration(),
            auth: this.configService.getAuthConfiguration(),
            license: this.licenseService.getLicenseInfo()
        }).subscribe({
            next: ({ idsLs, auth, license }) => {
                this.idsLsEnabled = idsLs.isEnabled;
                this.aasEnabled = auth.providerName === "AAS";
                this.license = license.licenseInfo;

                this.setupXHRInterceptor();
            },
            error: (error) => {
                console.error('Failed to load configuration', error);
                this.idsLsEnabled = false;
                this.aasEnabled = false;
            }
        });
    }

    private setupXHRInterceptor(): void {
        const originalSend = XMLHttpRequest.prototype.send;
        const self = this;

        XMLHttpRequest.prototype.send = function (body) {
            this.addEventListener('load', function () {
                const isError = this.status === 500;
                const forbiddenFlag = this.responseText && this.responseText.toLowerCase().includes('forbidden');
                const unauthorizedFlag = this.responseText && this.responseText.toLowerCase().includes('unauthorized');
                const licenseInvalidFlag = this.responseText && this.responseText.toLowerCase().includes('license invalid');

                if (self.aasEnabled && isError && unauthorizedFlag) {
                    console.log('AAS session expired, re-authenticating...');
                    self.renewAasSession();
                }
            });
            return originalSend.call(this, body);
        };
    }

    private renewAasSession() {
        const fullPath = window.location.pathname + window.location.search;
        const returnUrl = encodeURIComponent(fullPath);
        window.location.href = `${RoutesGlossary.RenewAasSession}?returnUrl=${returnUrl}`;
    }
}
